import * as React from 'react';

import type {Flow} from 'flow-to-typescript-codemod';
import type {GetAudienceForEntityList_audience as Audience} from 'nutshell-graphql-types';

import {useGetAudienceForEntityList} from '../../graphql/hooks/use-get-audience-for-entity-list';

import {EntityListTitleBar} from './entity-list-title-bar';
import type {OwnProps as EntityListTitleBarOwnProps} from './entity-list-title-bar';

type EntityListTitleBarProps = Flow.Diff<
    EntityListTitleBarOwnProps,
    {
        audience: Audience | null | undefined;
    }
>;

type Props = EntityListTitleBarProps & {
    audienceId: string;
};

export function EntityListTitleBarWrapper(props: Props) {
    const {audienceId, ...restProps} = props;

    const {audience} = useGetAudienceForEntityList(audienceId, restProps.entityType);

    return (
        <>
            <EntityListTitleBar audience={audience} {...restProps} />
        </>
    );
}
